import {HttpService} from "../http/HttpService";
import {UserService} from "../user/UserService";
import {SettingsUrl} from "../http/Types";
import {CasinoService} from "../casino/CasinoService";
import {PokerService} from "../casino/PokerService";
import {PaymentsService} from "../payments/PaymentsService";
import {TransactionService} from "../transactions/TransactionService";
import ContentfulClientService from "../contenful/ContentfulClientService";
import {BundleServicee} from "../store/BundleService";
import {SettingsService} from "../settings/SettingsService";
import {FacebookApi} from "../FacebookApi";
import {SportsbookService} from "../sports/SportsbookService";
import {NotificationsService} from "../notifications/NotificationsService";
import {RacingService} from "../racing/RacingService";
import {GeoIpService} from "../user/GeoIpService";
import {UserBonusService} from "../bonus/UserBonusService";
import {MessageService} from "../messages/MessageService";
import {UserRewardService} from "../rewards/UserRewardService";
import StrapiClient from "../contenful/StrapiClient";

var container : AppContext;

interface AppContext {
    getUserService() : UserService;
    getHttpService() : HttpService;
    getCasinoService() : CasinoService;
    getPokerService() : PokerService;
    getSportsbookService() : SportsbookService;
    getRacingService() : RacingService;
    getPaymentsService() : PaymentsService;
    getTransactionService() : TransactionService;
    getContentfulClientService(): ContentfulClientService;
    getSettingsService(): SettingsService;
    getFacebookApi() : FacebookApi;
    getBundleService(): BundleServicee;
    getNotificationsService(): NotificationsService;
    getGeoIpService() : GeoIpService;
    getUserBonusService() : UserBonusService;
    getMessageService() : MessageService;
    getUserRewardService() : UserRewardService;
    getStrapiClient() : StrapiClient;
}
export function wireApplication(settings : SettingsUrl, spaceId:string, accessToken:string, fb : FacebookApi, strapiApiUrl? : string) {
    let httpService = new HttpService(settings.baseUrl);
    let userService = new UserService(httpService);
    let casinoService = new CasinoService(httpService);
    let pokerService = new PokerService(httpService);
    let sportsbookService = new SportsbookService(httpService);
    let racingService = new RacingService(httpService);
    let paymentsService = new PaymentsService(httpService);
    let transactionService = new TransactionService(httpService);
    let contentfulClientService = new ContentfulClientService(spaceId, accessToken, false);
    let settingsService = SettingsService.getInstance(httpService);
    let bundleService = new BundleServicee(httpService);
    let notificationsService = new NotificationsService(httpService);
    let geoIpService = new GeoIpService(httpService);
    let userBonusService = new UserBonusService(httpService);
    let messageService = new MessageService(httpService);
    let userRewardService = new UserRewardService(httpService);
    let strapiClient = new StrapiClient(strapiApiUrl);
    container = {
        getHttpService: () => httpService,
        getUserService: () => userService,
        getCasinoService: () => casinoService,
        getPokerService : () => pokerService,
        getSportsbookService: () => sportsbookService,
        getRacingService: () => racingService,
        getPaymentsService : () => paymentsService,
        getTransactionService : () => transactionService,
        getContentfulClientService: () => contentfulClientService,
        getSettingsService : () => settingsService,
        getFacebookApi  :() => fb,
        getBundleService: () => bundleService,
        getNotificationsService: () => notificationsService,
        getGeoIpService: ()=> geoIpService,
        getUserBonusService : () => userBonusService,
        getMessageService : () => messageService,
        getUserRewardService : ()  => userRewardService,
        getStrapiClient :()=> strapiClient

    };
}
export function getContainer() : AppContext {
    return container;
}